import { createSlice } from '@reduxjs/toolkit'

interface AppState {
  isResetting: boolean
}

const initialState: AppState = {
  isResetting: false,
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    resetStore: (state) => {
      state.isResetting = true
    },
    resetStoreComplete: (state) => {
      state.isResetting = false
    },
  },
})

export const { resetStore, resetStoreComplete } = appSlice.actions
export default appSlice.reducer
